import validate from "/Users/wouter/prjs/wouter/krewebacchus/node_modules/.pnpm/nuxt@3.18.1_@parcel+watcher@2.5.1_@types+node@22.13.5_@vue+compiler-sfc@3.5.20_better-s_11a39451a577bef20859fcbcc9907341/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45auth_45global from "/Users/wouter/prjs/wouter/krewebacchus/middleware/01-auth.global.ts";
import manifest_45route_45rule from "/Users/wouter/prjs/wouter/krewebacchus/node_modules/.pnpm/nuxt@3.18.1_@parcel+watcher@2.5.1_@types+node@22.13.5_@vue+compiler-sfc@3.5.20_better-s_11a39451a577bef20859fcbcc9907341/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _01_45auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}